import { apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel } from '../../generic/systemValues/systemValueLabel'

const FabricationOrderStatusTypes = () => {
  const { t_ } = useSmartTranslation()

  const columns = [

    {
      name: t_('Code'),
      field: 'code',
      edit: false
    },
    {
      name: t_('Name'),
      field: 'name',
      edit: false,
      render: (row) => systemValueLabel(t_, 'fabrication_order_status_type', row),
      renderOnlyInReadMode: true

    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      render: (row) => systemValueDescription(t_, 'fabrication_order_status_type', row),
      renderOnlyInReadMode: true
    }
  ]

  const actions = {

    edit: {
      fetchFunction: (row) => {
        return apiPut('fabricationOrderStatusType', row)
      }
    }

  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='fabricationOrderStatusType'
      columns={columns}
      title={t_('Fabrication order status types')}
      dataFetch='fabricationOrderStatusType'
      actions={actions}
      pageable

    />
  )
}

export default FabricationOrderStatusTypes
